import { runJsonGet, runJsonPost } from '@/backend-client'
import { OPERATIONS_BACKEND_URL } from '@/config'

const BASE_URL = `${OPERATIONS_BACKEND_URL}/proof-of-delivery`

const transformPodDocument = podDocument => {
  return {
    fileName: podDocument.file_name,
    fileSize: podDocument.file_size,
    state: podDocument.state,
    created: new Date(podDocument.created),
    id: podDocument.id,
    error: podDocument.rejection_reason
  }
}

const transformPreseignedUploadRequest = uploadRequest => {
  return {
    url: uploadRequest.url,
    fields: uploadRequest.fields,
    uploadRequestId: uploadRequest.upload_request_id
  }
}

export const fetchCanSubmitFiles = orderId => {
  return runJsonGet(`${BASE_URL}/queries/documents-can-be-submitted/${orderId}`).then(
    response => response.data
  )
}

export const fetchPodDocuments = orderId => {
  return runJsonGet(`${BASE_URL}/queries/get-all-documents-for-carrier/${orderId}`)
    .then(response => response.data.proof_of_delivery_documents)
    .then(pods => pods.map(transformPodDocument))
}

export const fetchPodProcessStatus = orderId => {
  return runJsonGet(`${BASE_URL}/get-process-status/${orderId}`).then(
    response => response.data.step
  )
}

export const deletePodDocument = id => {
  return runJsonPost(`${BASE_URL}/delete-document/${id}`)
}

export const submitPodDocuments = orderId => {
  return runJsonPost(`${BASE_URL}/submit-documents/${orderId}`)
}

export const fetchMissingDocuments = orderId => {
  return runJsonGet(`${BASE_URL}/get-all-missing-document/${orderId}`).then(
    response => response.data.missing_documents
  )
}

export const fetchPresignedUploadRequest = ({ orderId, fileName, fileSize }) => {
  const data = { file_name: fileName, file_size: fileSize }
  return runJsonPost(`${BASE_URL}/queries/generate-upload-request/${orderId}`, data)
    .then(response => response.data)
    .then(transformPreseignedUploadRequest)
}

export const createUploadedPodDocument = (orderId, uploadRequestId, fileName) => {
  return runJsonPost(`${BASE_URL}/commands/create-document/${orderId}`, {
    upload_request_id: uploadRequestId,
    file_name: fileName,
    origin: 'sennder_frontend'
  })
}

export const canUploadPodDocuments = orderId => {
  return runJsonGet(`${BASE_URL}/queries/pod-uploaded-ready-to-expose/${orderId}`).then(
    response => response.data
  )
}
